import { render, staticRenderFns } from "./LaundryTypes.vue?vue&type=template&id=470c4611&scoped=true"
import script from "./LaundryTypes.vue?vue&type=script&lang=js"
export * from "./LaundryTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c4611",
  null
  
)

export default component.exports